import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import AuthContext from 'context/authContext';
import React, { useContext, useMemo, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { TestScheduler } from './Scheduler';
import AddEventModal from './addEventModal';
import {
  getCalendarEvents,
  insertCalendarEvent,
  updateCalendarEvent
} from 'lib/supabaseQueries';

function EventScheduler() {
  const [show, setShow] = useState(false);
  const { organization, selectedBranchId } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const { data: eventData, isLoading: getEventLoading } = useQuery({
    queryKey: ['calendarEvents', organization?.id, selectedBranchId],
    queryFn: () => getCalendarEvents(organization.id, selectedBranchId),
    enabled: !!organization?.id && !!selectedBranchId
  });

  const addEventMutation = useMutation({
    mutationFn: insertCalendarEvent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendarEvents'] });
      toast.success('Event Added successfully');
    },
    onError: error => {
      console.error(error);
      toast.error('Something went wrong');
    }
  });

  const updateEventMutation = useMutation({
    mutationFn: ({ id, data }) => updateCalendarEvent(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendarEvents'] });
      toast.success('Event Updated successfully');
    },
    onError: error => {
      console.error(error);
      toast.error('Something went wrong');
    }
  });

  const onSubmit = data => {
    const startDateTime = new Date(data.startDate);
    startDateTime.setHours(startDateTime.getHours() + 5);
    startDateTime.setHours(Number(data.startTime.split(':')[0]) + 5);
    startDateTime.setMinutes(data.startTime.split(':')[1]);
    const endDateTime = new Date(data.endDate);
    endDateTime.setHours(endDateTime.getHours() + 5);
    endDateTime.setHours(Number(data.endTime.split(':')[0]) + 5);
    endDateTime.setMinutes(data.endTime.split(':')[1]);

    addEventMutation.mutate({
      branch_id: selectedBranchId,
      organisation_id: organization.id,
      text: data.text,
      start_date: startDateTime.toISOString(),
      end_date: endDateTime.toISOString()
    });
    setShow(false);
  };

  const events = useMemo(() => {
    return eventData?.data?.map(item => {
      return {
        ...item,
        end_date:
          item.end_date.split('T')[0] +
          ' ' +
          item.end_date.split('T')[1].split('+')[0],
        start_date:
          item.start_date.split('T')[0] +
          ' ' +
          item.start_date.split('T')[1].split('+')[0]
      };
    });
  }, [eventData]);
  return (
    <div className="bg-white">
      <div className="d-flex justify-content-end pt-3 pb-3 pe-2">
        <Button onClick={() => setShow(true)}>Add a new Event</Button>
      </div>
      {addEventMutation.isPending || getEventLoading || updateEventMutation.isPending ? (
        <Spinner />
      ) : (
        <>
          {events !== undefined && (
            <>
              <TestScheduler events={events} onUpdate={(data) => updateEventMutation.mutate(data)} />
            </>
          )}
        </>
      )}

      {show && (
        <AddEventModal
          show={show}
          onSubmit={onSubmit}
          onHide={() => setShow(false)}
        />
      )}
    </div>
  );
}

export default EventScheduler;
